<template>
  <div class="arriendos-layout">
    <nav class="arriendos-sidebar">
      <ul class="arriendos-nav">
        <li><button class="button-71" :class="{ selected: isSelected('ContratosVigentes') }" @click="goTo('ContratosVigentes')">Contratos Vigentes</button></li>
        <li><button class="button-71" :class="{ selected: isSelected('ContratosMorosos') }" @click="goTo('ContratosMorosos')">Contratos Morosos</button></li>
        <li><button class="button-71" :class="{ selected: isSelected('Contratos') }" @click="goTo('Contratos')">Contratos</button></li>
        <!--<li><button class="button-71" :class="{ selected: isSelected('Pagos') }" @click="goTo('Pagos')">Pagos</button></li>
        <li><button class="button-71" :class="{ selected: isSelected('Cobros') }" @click="goTo('Cobros')">Cobros</button></li>-->
        <li><button class="button-71" :class="{ selected: isSelected('Propiedades') }" @click="goTo('Propiedades')">Propiedades</button></li>
      </ul>
    </nav>
    <div class="arriendos-content">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArriendosIndex',
  methods: {
    goTo(name) {
      const routeMap = {
        'ContratosVigentes': { name: 'ContratosVigentes' },
        'ContratosMorosos': { name: 'ContratosMorosos' },
        'Contratos': { name: 'Contratos' },
        //'Pagos': { path: '/arriendos/pagos' },
        //'Cobros': { path: '/arriendos/cobros' },
        'Propiedades': { path: '/arriendos/propiedades' },
      };
      this.$router.push(routeMap[name]);
    },
    isSelected(name) {
      if (name === 'ContratosVigentes') return this.$route.name === 'ContratosVigentes' || this.$route.path === '/arriendos';
      if (name === 'ContratosMorosos') return this.$route.name === 'ContratosMorosos';
      if (name === 'Contratos') return this.$route.name === 'Contratos';
      // if (name === 'Pagos') return this.$route.path === '/arriendos/pagos';
      // if (name === 'Cobros') return this.$route.path === '/arriendos/cobros';
      if (name === 'Propiedades') return this.$route.path === '/arriendos/propiedades';
      return false;
    }
  },
};
</script>

<style scoped>
.arriendos-layout {
  display: flex;
  min-height: 100vh;
}
.arriendos-sidebar {
  width: 260px;
  min-width: 220px;
  background: #f8f8f8;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2em 1em 1em 1em;
  gap: 2em;
  height: 100vh;
  box-sizing: border-box;
}
.arriendos-nav {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}
.arriendos-nav li {
  display: block;
  width: 100%;
}
.arriendos-content {
  margin-top: 1rem;
  flex: 1;
  padding: 2em 2em 2em 2em;
}
.button-71 {
  background-color: #0078d4;
  border: none;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08), 0 0.5px 1.5px rgba(0,0,0,0.08);
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: "Segoe UI", Arial, sans-serif;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.7em 1.5em;
  margin: 0.2em 0;
  transition: background 0.2s, box-shadow 0.2s, transform 0.1s;
  outline: none;
  width: 100%;
  text-align: left;
  width:12em;
}
.button-71.selected {
  background-color: #22c55e !important;
  color: #fff;
  box-shadow: 0 4px 12px rgba(34,197,94,0.15);
  transform: scale(1.0);
}
.button-71:hover, .button-71:focus {
  background-color: #005fa3;
  box-shadow: 0 4px 8px rgba(0,0,0,0.12), 0 1.5px 3px rgba(0,0,0,0.12);
  transform: translateY(-2px) scale(1.03);
}
.button-71:active {
  background-color: #004c87;
  box-shadow: 0 1px 2px rgba(0,0,0,0.10);
  transform: none;
}
</style>
